export enum FeatureToggle {
  ProductsViewPage = 'rt_products_view_page',
  ProductViewPageShowLegacyEdit = 'rt_product_view_page_show_legacy_edit',
  ProductsViewPageShowRetailerLabelsOnlyOnStoreFrontPro = 'rt_products_view_page_only_show_retailer_label_ma_values',
  ProductSearchCPTButton = 'rt_catalog_product_search_report_cpt_problem',
  RetailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
  SproutsTempOverrideEnabled = 'rt_catalog_sprouts_imporved_product_search',
}
